import React,{useState} from 'react'
import FormInput from '../form-input/form-input.component'
import CustomButton from '../custom-button/custom-button.component'
import firebase from 'firebase/app';
import {addProduct} from '../../firebase/firebase.utils'
import 'firebase/storage';
const AddProduct = () => {
    const [productData,setProductData] = useState({
        id: Math.floor(Math.random() * 1000000000),
        name: '',
        quantity: '',
        unit: '',
        description : '',
        price: 0,
        imageUrl: '',
        file: '',
        documentTo : ''
    })
    const documents = [
        'Fakruddin Lunch and Dinner',
        'Hakka Dhaka',
        'Sea Shell',
        'Caspian Persian & Peshawari Cuisine',
        'Platter',
        'Chillis GZ',
        'Shumis Hot Cake',
        'Aaheli Kabab & Restaurant',
        'Boomers Cafe',
        'Kabab Factory',
        'KFC',
        'Thirty3',
        'Cheers Restaurant',
        'Hazi Biryani',
        'Tune & Bite Music Cafe',
        'Mr Burger',
        'Hakka',
        'Grocery',
        'Bitter Sweet Cafe',
        'Takeout Banani',
        'La Bamba',
        'Grand Prince Thai & Chinese Restaurant',
        'Star Hotel & Restaurant',
        'Pizza Inn',
        'Pizza Hut',
        'Lake Terrace',
        'Korai Gost',
        'Chiling Thai Chinese & Indian Restaurant',
        'Burger King',
        'Al Fresco',
        'Nandos',
        'BAR B Q TONITE',
        'De Castle Restaurant',
        'Cafe Appeliano',
        'Cafe Cherry Drops',
        'Monster Foods',   
        'Roll Xpress Cafe',
        'Pizza End',
        'Broccoli Restaurant',
        'Olympia Palace Restaurant',
        'Absolute Thai',
        'Cheong Shing Chinese Restaurant',
        'Shawarma King',
        'Fakruddin Biryani',
        'Jollichickn',
        'Helvetia',
        'Sultan s Dine',
        'Fish Chicken & Beef',
        'California Fried Chicken',
        'Dominos Pizza',
        'Kacchi Vai',
        'Khazana',
        'Mainland China',
        'FFC',
        'Sub Lovers',
        'China Park',
        'Dhaba Banani',
        'Chaap Shamlao',
        'Shawarma House',
        'Boomers Cafe',
        'Baburchi Restaurant',
        'Golden Spoon',
        'Johnny Rockets',
        'Handi',
        'Red Court',
        'BFC',
        'Rice & Noodle',
        'Dawat',
        'Swiss Bakery',
        'Rice & Noodle',
        'Red Tomato',
        'Bhojon Bari',
        'Time Out Gulshan',
        'Al Kaderia Restaurant',
        'Gloria Jeans',
        'Dhaba',
        'Fastway',
        'Mobile Recharge',
        'Pizza Margherita'
]
    const {name,quantity,unit,price,imageUrl,file,documentTo,id} = productData
    const handleChange = event => {
        const {value,name} = event.target;
        setProductData({...productData,[name]: value})
    }
    const handleImage = event => {
        const {value,name} = event.target
        setProductData({...productData,[name]: value})
        var fil = event.target.files[0]
        var storageRef = firebase.storage().ref();
        var uploadTask = storageRef.child('images/' + fil.name).put(fil);

        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        function(snapshot) {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
                alert('Upload Paused')
                break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
                alert(`File is Uploading ${progress}%`);
                break;
            }
        }, function(error) {
        switch (error.code) {
            case 'storage/unauthorized':
            alert('Upload Failed')
            break;
            case 'storage/canceled':
                alert('Upload Failed')
            break;
            case 'storage/unknown':
                alert('Upload Failed')
            break;
        }
        }, function() {
        // Upload completed successfully, now we can get the download URL
        uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            setProductData({...productData,imageUrl:downloadURL})
        });
        });
    }
    const handleSubmit = async event => {
        event.preventDefault();
        let product = {
            name : name,
            id: id,
            quantity: quantity,
            unit: unit,
            description : '',
            price: price,
            imageUrl: imageUrl,
        }
        addProduct(product,documentTo)
        setProductData({
            id: Math.floor(Math.random() * 1000000000),
            name: '',
            quantity: '',
            unit: '',
            description : '',
            price: 0,
            imageUrl: '',
            file: '',
            documentTo : ''
        })
    }
    
    return(
        <div>
            <h2>Add Product</h2>
            <form onSubmit={handleSubmit}>
            <FormInput 
                type="text" 
                name="name" 
                value={name} 
                required 
                handleChange={handleChange}
                label='Name'
            />
             <FormInput 
                type="tel" 
                name="price" 
                value={price} 
                required 
                handleChange={handleChange}
                label='Price'
            />
             <FormInput 
                type="text" 
                name="quantity" 
                value={quantity} 
                handleChange={handleChange}
                label='Quantity(Optional)'
            />
             <FormInput 
                type="text" 
                name="unit" 
                value={unit}  
                handleChange={handleChange}
                label='Unit(Optional)'
            />
             <FormInput 
                type="file" 
                name="file" 
                value={file}  
                handleChange={handleImage}
                label=''
            />
            <label>Select Category</label>
            <select style={{
                margin: '10px',
                padding: '10px'
            }} name='documentTo' value={documentTo} onChange={handleChange} id="Category">
                <option value="None">Select an option</option>
                {
                    documents.map(document=>(
                        <option key={document} value={document}>{document}</option>
                    ))
                }
                
            </select>
            <CustomButton type="submit">Submit</CustomButton>
            </form>
        </div>
    )
}
export default AddProduct